import React from "react";
import api from "../../api/resources";

const initialData = {
  resources: [],
  createdResource: null,
  deletedResource: null,
  isCreatingResource: false
};

export default function useResources() {
  const [resData, setResourceData_] = React.useState(initialData);

  const setResourceData = newData => {
    const newResourceData = {
      ...resData,
      ...newData
    };

    setResourceData_(newResourceData);
  };

  function getResources() {
    api.getResourceList()
      .then(({ data }) => setResourceData({ resources: data }));
  }

  function deleteResources(idList) {
    Promise.all(idList.map(api.deleteResource)).then(response => {
      setResourceData({ deletedResource: response });
      getResources();
    });
  }

  function createResource(data) {
    setResourceData({ isCreatingResource: true });
    api.createResource(data)
      .then(({ data }) => {
        setResourceData({ createdResource: data, isCreatingRoom: false });
        getResources();
      })
      .catch(() => {
        setResourceData({ isCreatingResource: false });
      });
  }

  return { resData, getResources, deleteResources, createResource };
}
